import { createContext } from 'react';

// Comunica às páginas que os avisos devem aguardar as pendências cadastrais.
export const RegistrationPendingContext = createContext(false);
